//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { roleAdd } from 'api/prokey/prokey.websocket';
// === STYLES ===
import { makeStyles } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
} from '@mui/material';




//#endregion

function AddRoleDialog(props) {
  //#region [VALUES]
  const [roleName, setRoleName] = useState('');

  const [showAlert, setShowAlert] = useState(false);
  const [alertErrText, setAlertErrText] = useState('');

  //#endregion

  //#region [EFFECT]

  useEffect(() => {}, [props.showDialog]);

  //#endregion

  //#region [MODIFY]

  function addRole() {
    let errorText = '';
    if (!roleName) errorText += ', Role Name must be filled';

    if (errorText) {
      setAlertErrText(errorText.substring(2));
      setShowAlert(true);
      return false;
    } else {
      roleAdd(`${roleName}`);
      return true;
    }
  }

  const handleSubmitAddRoleAndClose = (e) => {
    if (addRole()) handleClose();
    setRoleName('');
  };

  const handleClose = () => {
    props.setShowDialog(false);
    handleDismissAlert();
    setRoleName('');
  };

  const handleDismissAlert = () => {
    setShowAlert(false);
    setAlertErrText('');
  };

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // ALERT
  function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }
  const handleErrClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };
  const displayError = () => {
    return (
      <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleErrClose}>
        <Alert onClose={handleErrClose} severity='error'>
          {alertErrText}
        </Alert>
      </Snackbar>
    );
  };

  // ------------------------------------------------------
  // MODAL

  function displayAddRoleModal() {
    return props.showDialog ? (
      <div>
        <Dialog open={props.showDialog} onClose={handleClose} aria-labelledby='form-dialog-title'>
          <DialogTitle id='form-dialog-title'>Add Role</DialogTitle>
          <DialogContent>
            <DialogContentText>Specify a new role name below</DialogContentText>
            <TextField
              autoFocus
              margin='dense'
              id='name'
              label='Role Name'
              type='text'
              fullWidth
              value={roleName}
              autoComplete='off'
              onChange={(e) => {
                setRoleName(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary'>
              Cancel
            </Button>
            <Button onClick={handleSubmitAddRoleAndClose} color='primary'>
              Add & Close
            </Button>
          </DialogActions>
        </Dialog>
        {displayError()}
      </div>
    ) : null;
  }
  //#endregion

  return displayAddRoleModal();
}

export { AddRoleDialog };
